export default __webpack_public_path__ + "static/media/pictogramThumbUp64.6922956b.svg";